import { render, staticRenderFns } from "./AlbumImportZone.vue?vue&type=template&id=18b73a40&scoped=true&"
import script from "./AlbumImportZone.vue?vue&type=script&lang=js&"
export * from "./AlbumImportZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumImportZone.vue?vue&type=style&index=0&id=18b73a40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b73a40",
  null
  
)

export default component.exports